import { adminApiClient } from '../utils/apiClient';

/**
 * Subscriber JWT routes under /me (Bearer token from unified login).
 * Paths match api-hawk src/api/routers/subscriber_me.py
 */
export const subscriberMeApi = {
  getProfile: () => adminApiClient.get('/me/profile'),
  getPreferences: () => adminApiClient.get('/me/preferences'),
  putPreferences: (body) => adminApiClient.put('/me/preferences', body),
  getAvailableTemplates: () => adminApiClient.get('/me/available-templates'),
  /** System-level email templates (if enabled on backend). */
  getSystemTemplates: () => adminApiClient.get('/me/templates'),

  getNewsletters: (params) => adminApiClient.get('/me/newsletters', { params }),
  getNewsletter: (id) => adminApiClient.get(`/me/newsletters/${id}`),
  /** Latest non-rejected newsletter draft for this subscriber (may 404). */
  getNewsletterPreview: () => adminApiClient.get('/me/newsletter/preview'),

  // --- Subscribed topics (moderator catalog, UserTopic junction) ---
  getSubscribedTopics: () => adminApiClient.get('/me/subscribed-topics'),
  subscribeSubscribedTopic: (topicId) =>
    adminApiClient.post(`/me/subscribed-topics/${topicId}`),
  unsubscribeSubscribedTopic: (topicId) =>
    adminApiClient.delete(`/me/subscribed-topics/${topicId}`),
  getSubscribedTopicBuzzwords: (topicId) =>
    adminApiClient.get(`/me/subscribed-topics/${topicId}/buzzwords`),

  // --- Subscriber-owned topics & buzzwords ---
  getOwnTopics: () => adminApiClient.get('/me/topics'),
  /** @param {{ topic: string }} body */
  createOwnTopic: (body) => adminApiClient.post('/me/topics', body),
  deleteOwnTopic: (topicId) => adminApiClient.delete(`/me/topics/${topicId}`),
  getOwnBuzzwords: () => adminApiClient.get('/me/buzzwords'),
  /** @param {{ topicId: number, buzzword: string }} body */
  createOwnBuzzword: (body) => adminApiClient.post('/me/buzzwords', body),
  deleteOwnBuzzword: (buzzwordId) => adminApiClient.delete(`/me/buzzwords/${buzzwordId}`),
};
